import { useTranslation } from "react-i18next";
import { DownloadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import { FileElementProps, FileGroupElementProps } from "./types";
import BaseButton from "../Button/BaseButton";

import "./styles.css";

export const FileElement = ({ value }: FileElementProps) => {
  const { t } = useTranslation();

  const handleDownloadFile = () => {
    const link = document.createElement("a");
    link.href = value.downloadUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="flex items-center justify-between full-width">
      <Link
        className="file-element-item body-m-regular"
        to={value.file}
        target="_blank"
      >
        {value.name}
      </Link>

      <BaseButton
        size="small"
        variant="link"
        leadingIcon={<DownloadOutlined />}
        onClick={handleDownloadFile}
      >
        {t("buttons.download")}
      </BaseButton>
    </div>
  );
};

export const FileGroupElement = ({ value }: FileGroupElementProps) => {
  return (
    <div>
      {value.map((val, index) => (
        <FileElement value={val} key={`${val.name}-${index}`} />
      ))}
    </div>
  );
};
